import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import TextColor from "../../../../ConfigParameters/ConfigParameters/TextColor";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import BackgroundColor from "../../../../ConfigParameters/ConfigParameters/BackgroundColor";
import Borders from "../../../../ConfigParameters/ConfigCollections/Borders";
import LabelWidth from "../../../../ConfigParameters/ConfigParameters/LabelWidth";
import LabelsPosition from "../../../../ConfigParameters/ConfigParameters/LabelsPosition";
import Recaptcha from "../../../../ConfigParameters/ConfigParameters/Recaptcha";
import EditForm from "../../../../ConfigParameters/ConfigParameters/EditForm";
import ThankYouText from "../../../../ConfigParameters/ConfigParameters/ThankYouText";
import ThankYouTargetUrl from "../../../../ConfigParameters/ConfigParameters/ThankYouTargetUrl";
import ZapierWebhookUrl from "../../../../ConfigParameters/ConfigParameters/ZapierWebhookUrl";
import SendFormDataByMail from "../../../../ConfigParameters/ConfigParameters/SendFormDataByMail";
import SendMailToUser from "../../../../ConfigParameters/ConfigParameters/SendMailToUser";
import FormContent from "../../../../ConfigParameters/ConfigParameters/FormContent";
import LabelsAlign from "../../../../ConfigParameters/ConfigParameters/LabelsAlign";
import contentGuardService from "../../../../Workspace/ContentGuard/ContentGuardService";
import MailsResource from "../../../../../MailsModules/MailsResource";
import FormTemplate from "../../../../ConfigParameters/ConfigParameters/FormTemplate";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageForm';

const creatorPageSectionForm = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: require('./form.html'),
    controller: function (ToolbarService, ContentGuardService, $scope, gettextCatalog) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);
        defaultConfig.thankYouText = gettextCatalog.getString('Your entry has been saved');

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
            ContentGuardService.registerLocked(MODULE_NAME);
        };

        $scope.$on('$destroy', () => {
            ContentGuardService.deregisterLocked(MODULE_NAME);
        });
    }
};

export default angular.module('cms.creator.page.section-form', [sectionsLibraryService, toolbarService, contentGuardService, MailsResource])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator, MailsResource, ACLService) {

        SectionsLibraryService.registerSection({
            icon: 'assignment',
            type: MODULE_NAME,
            label: gettext('Form'),
            group: 'page',
            options: {
                disableCopy: true
            },
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                borders: {
                    label: gettext('Input borders'),
                    isOpen: false,
                    type: 'borders'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });
        let formTemplate = new FormTemplate();
        let sendMailToUser = new SendMailToUser();

        formTemplate.setOptions( () => {
            let options = [{value: null, label: gettext("Choose...")}];
            if(ACLService.matchRoles(['ROLE_ADMIN'])) {
                MailsResource.findAll(null, (response) => {
                    if (!response.data.error) {
                        angular.forEach(response.data, (mail) => {
                            options.push({value: mail.id, label: mail.title});
                        });
                    }
                }, err => {
                });
            }
            return options;
        });

        sendMailToUser.setValidator ( (form) =>{
            let errorMessage = gettext('You have to choose e-mail template');
            if(!form.formTemplate && form.sendMailToUser){
                return errorMessage;
            }
        });

        formTemplate.setValidator( (form) => {
            if(!form.formTemplate) {
                return;
            }

            let errorMessage = gettext('Your form must have 1 required e-mail field!');
            let formFieldCounter = 0;

            angular.forEach(form.content, (field) => {
                if(field.type === 'formEmail' && field.config.required) {
                    formFieldCounter++;
                }
            });

            if(formFieldCounter !== 1) {
                return errorMessage;
            }

            return;
        });

        if(!ACLService.matchRoles(['ROLE_ADMIN'])) {
            formTemplate.setAclDisable(true);
            formTemplate.setHelper(gettext('Option is available only in full version of the product.'));
        }


        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new FormContent()),
            ...(formTemplate),
            ...(new EditForm()),
            ...(new TextColor()),
            ...(new BackgroundColor()),
            ...(new ThankYouText()),
            ...(new ThankYouTargetUrl()),
            ...(new ZapierWebhookUrl()),
            ...(new SendFormDataByMail()),
            ...(sendMailToUser),
            ...(new Recaptcha()),
            ...(new Borders()),
            ...(new Paddings()),
            ...(new LabelsPosition()),
            ...(new LabelWidth()),
            ...(new LabelsAlign()),
            ...(new CustomClassName())
        });

    })
    .component('cmsCreatorPageSectionForm', creatorPageSectionForm).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Form/Form.js